import React from "react";

import "./Footer.css";
const Footer = () => {
  return (
    <>
      <div className="footer__parent">
        <div className="footer">
          <h1>Copyright 2022 All Right Reserved By SG</h1>
        </div>
      </div>
    </>
  );
};

export default Footer;
